export default {
  queryPrepareCancelTimeText: '/courier/api/financial/queryPrepareCancelTimeText',
  queryCourierStatus: '/courier/api/financial/queryCourierStatus'
}
